Game.Utils.Philosophy = {

	getRandom: function() {

		return Game.JSON.quotes[ Math.floor( Math.random() * this.count() ) ];

	},

	count: function() {

		return Game.JSON.quotes.length

	}

};